import React, { useState } from 'react';
import { Layout, Menu, Button, Dropdown, Avatar, theme } from 'antd';
import { Outlet, useNavigate, useLocation } from 'react-router-dom';
import {
  MenuFoldOutlined,
  MenuUnfoldOutlined,
  VideoCameraOutlined,
  TeamOutlined,
  AlertOutlined,
  NotificationOutlined,
  SettingOutlined,
  BarChartOutlined,
  UserOutlined,
  LogoutOutlined
} from '@ant-design/icons';
import './MainLayout.css';

const { Header, Sider, Content } = Layout;

const MainLayout = () => {
  const [collapsed, setCollapsed] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const {
    token: { colorBgContainer, borderRadiusLG },
  } = theme.useToken();

  // 菜单项配置
  const menuItems = [
    {
      key: 'video-management',
      icon: <VideoCameraOutlined />,
      label: '视频管理',
      onClick: () => navigate('/video-management')
    },
    {
      key: 'people-flow-detection',
      icon: <TeamOutlined />,
      label: '人流检测',
      onClick: () => navigate('/people-flow-detection')
    },
    {
      key: 'warning-management',
      icon: <AlertOutlined />,
      label: '警告管理',
      onClick: () => navigate('/warning-management')
    },
    {
      key: 'push-management',
      icon: <NotificationOutlined />,
      label: '推送管理',
      onClick: () => navigate('/push-management')
    },
    {
      key: 'system-management',
      icon: <SettingOutlined />,
      label: '系统管理',
      onClick: () => navigate('/system-management')
    },
    {
      key: 'statistics',
      icon: <BarChartOutlined />,
      label: '统计模块',
      onClick: () => navigate('/statistics')
    },
  ];

  // 用户下拉菜单
  const userMenuItems = [
    {
      key: '1',
      icon: <UserOutlined />,
      label: '个人信息',
    },
    {
      key: '2',
      icon: <SettingOutlined />,
      label: '账户设置',
    },
    {
      key: '3',
      icon: <LogoutOutlined />,
      label: '退出登录',
      onClick: () => {
        localStorage.removeItem('user');
        navigate('/login');
      },
    },
  ];

  // 获取当前选中的菜单项
  const getSelectedKey = () => {
    const path = location.pathname.split('/')[1];
    return path ? path : 'video-management';
  };

  return (
    <Layout className="layout-container">
      <Sider trigger={null} collapsible collapsed={collapsed} theme="dark">
        <div className="logo">AI视频监控平台</div>
        <Menu
          theme="dark"
          mode="inline"
          selectedKeys={[getSelectedKey()]}
          items={menuItems}
        />
      </Sider>
      <Layout>
        <Header style={{ padding: 0, background: colorBgContainer }}>
          <Button
            type="text"
            icon={collapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}
            onClick={() => setCollapsed(!collapsed)}
            style={{ fontSize: '16px', width: 64, height: 64 }}
          />
          <div className="header-right">
            <Dropdown menu={{ items: userMenuItems }} placement="bottomRight">
              <Button type="text" icon={<Avatar icon={<UserOutlined />} />}>
                admin
              </Button>
            </Dropdown>
          </div>
        </Header>
        <Content className="main-content" style={{ background: colorBgContainer, borderRadius: borderRadiusLG }}>
          <Outlet />
        </Content>
      </Layout>
    </Layout>
  );
};

export default MainLayout;
